import { render, staticRenderFns } from "./MultiSite.vue?vue&type=template&id=53dc1dbe&scoped=true&"
import script from "./MultiSite.vue?vue&type=script&lang=js&"
export * from "./MultiSite.vue?vue&type=script&lang=js&"
import style0 from "./MultiSite.vue?vue&type=style&index=0&id=53dc1dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc1dbe",
  null
  
)

export default component.exports